import styled from "styled-components";

export const Button = styled.button`
  padding: 16px 20px;
  outline: none;
  border: none;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
  background-color: #1c1c1c;
  color: white;
  font-weight: 600;
  font-size: 16px;
  max-width: 350px;
`;